import * as React from 'react';

import { MountPopup } from '../PopupViewer/';
import { ClickOutside, IOutsideClickEvent } from '../outside/';
import { Clickable } from '../Clickable/';
import { Icon } from '../Icon/';

import * as styles from './styles/Modal.css';

interface IModalProps {
  component: React.ReactNode;
  placement?: 'top' | 'bottom' | 'right' | 'left' | 'middle';
  onChange?(isOpen: boolean): void;
  isOpen?: boolean;
  width?: string;
  dataMark?: string;
}

interface IModalState {
  isOpen: boolean;
}
export class Modal extends React.PureComponent<IModalProps, IModalState> {
  public state: Readonly<IModalState> = {
    isOpen: false,
  };

  public static getDerivedStateFromProps(nextProps: IModalProps, state: IModalState) {
    if (nextProps.isOpen === state.isOpen) {
      return null;
    }

    return { isOpen: nextProps.isOpen };
  }

  public render() {
    const {
      children,
      component,
      width,
      dataMark = 'Modal',
    } = this.props;

    const {isOpen} = this.state;

    const inlineStyles = width
      ? {
        width,
      }
      : {};

    return (
      <MountPopup
        placement="middle"
        data-mark={dataMark}
        component={
          isOpen &&
            <div className={styles['layout']} >
              <div
                className={styles['container']}
                style={inlineStyles}
              >
                <ClickOutside onOutside={this.handleClickOutside}>
                  <div className={styles['content']}>
                    {component}
                  </div>
                </ClickOutside>
                <div className={styles['close']} >
                  <Clickable onClick={this.toggleClose}>
                    <div className={styles['close_zone']} >
                      <Icon type="close" size={14} color="gray_4" colorHovered="black" />
                    </div>
                  </Clickable>
                </div>
                </div>
            </div>
        }
      >
        <Clickable onClick={this.toggleOpen}>
          {children}
        </Clickable>
      </MountPopup>
    );
  }
  private toggleOpen = () => {
    const { onChange } = this.props;

    if (onChange) {
      onChange(true);
    }

    this.setState({ isOpen: true});
  }

  private toggleClose = () => {
    const { onChange } = this.props;

    if (onChange) {
      onChange(false);
    }

    this.setState({ isOpen: false});
  }

  private handleClickOutside = (e?: IOutsideClickEvent) => {
    if (e && e.target && !e.target.className.includes('Modal__layout')) { return; }

    this.toggleClose();
  }
}
